<script>
	export let data = {
		margin: 1,
		line: "+",
	};
</script>

<div class="UILine _{data.type}" style="padding:{data.margin}em 0">
	{#if data.line === "+"}
		<hr />
	{/if}
</div>

<style global>
	.UILine > hr {
		border: none;
		height: 1px;
		background-color: #ccc;
		margin: 0;
	}
	.UILine._dashed > hr {
		border: 1px dashed #ccc;
		background-color: transparent;
		margin: 0;
		height: auto;
	}
</style>
